import addIEBodyClass from './detect-ie/detect-ie';

addIEBodyClass();

export const inputRegex = {
	MOBILE_PHONE: '^(?:\\+36|06)-?(1|70|20|30|31|21)-?\\d{3}-?\\d{4}$',
	LANDLINE_PHONE: '^(?:\\+36|06)-?(?!(?:20|30|31|70|21))\\d{2}-?\\d{3}-?\\d{3}$',
	ZIP_CODE: '^\\d{4}$',
	TAX_NUMBER: '^[0-9]{8}(-?)[0-9]{1}\\1[0-9]{2}$',
	REGISTRATION_NUMBER: '^([0-9]{2}-[0-9]{2}-[0-9]{6}|\\d{10})$'
};

export const respoBreakPoints = {
	mobile: 479,
	tablet: 768,
	desktop: 1024
};

export const respoBreakPointBands = {
	mobile: '(max-width: 767px)',
	tablet: '(min-width: 768px)',
	desktop: '(min-width: 1024px)'
};

export const getQueryParameterByName = name => {
	const paramValue = new URLSearchParams(location.search).get(name);

	return paramValue;
}




// WEBPACK FOOTER //
// ../source/common/common.js